<template>
    <div>
        <div class="card-body container px-0">
            
                <table class="employee-list-table"  >
                    <tr class="table-head">
                        <td>Name</td>
                        <td>Phone Number</td>
                        <td>Email</td>                            
                        <td>Job Position</td>
                        <td>Department</td>
                        <td>Branch</td>
                        <td></td>
                    </tr>
                    <tr class="hover-bg" v-for="employee in paginatedData" :key="employee.employee_id">
                        <td >
                            {{employee.name}}
                        </td>
                        <td>{{employee.phone}}</td>
                        <td >{{employee.email}}</td>                            
                        <td>{{employee.jobposition}}</td>
                        <td>{{employee.department}}</td>
                        <td>{{employee.branch}}</td>
                        <td class="cursor-pointer" @click="leaveAttendance(employee.employee_id , 0)"><span>Leave/Attendance</span></td>
                    </tr>
                </table>
            
            
            <div class="row p-2 float-right" v-if="paginatedData.length > 0">
                <div class="row p-2 float-right" v-if="paginatedData.length > 0">                
                    <ul class="pagination b-pagination">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled"><b-form-select v-model="length" :options="length_options"></b-form-select></li>
                        <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                    </ul>
                    <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ></b-pagination-nav>
                </div>
            
            </div>
            
        </div>

        <b-modal id="bv-modal-setsubordinate" hide-footer title="Subordinate" size="xl">
            <subordinate  :key="c"></subordinate>

        </b-modal>
    </div>

</template>
<script>
    export default{
        props: [],        
        
        data(){
           

            return {
                              
                c : 0,
                employees : [],                
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                
                notice: "Looks like you have not added any employee yet.",
                blankmsg : 'Fetching data..',
                people:0,

                depertments:[],
                jobtypes:[],
                branches:[],
                leave_policies : [],
                manager:[],
                

                search:'',
                length: 20,
                length_options: [],
            }
        },
        methods:{            

            leaveAttendance : function(id)
            {

                let formData = new FormData();
                formData.append('employee_id', id);
                axios.post(this.$api_url+'/employee/setsubordinate', formData)
                    .then(function (response) 
                    {   
                        this.c = this.c + 1;
                        this.$bvModal.show('bv-modal-setsubordinate');
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            
            setPagination: function(pageflg)
            {                
                if(pageflg)
                    this.pagination.currentPage = this.pagination.nextPage;
                else    
                    this.pagination.currentPage = this.pagination.prevPage;
                
                this.getEmployees();
            },
            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;

                axios.get(this.$api_url+'/subordinate/list/' , {
                    params: {
                        page: this.pagination.currentPage,
                        //per_page: this.per_page,
                        search_query: this.search_group,
                        search_query_by_id: this.search_by_id,
                    }
                    }).then(function(response){
                        
                        this.showoverlay = false;
                        if(response.data.error == 1)
                            this.notice = response.data.notice;
                        else
                        {
                            this.employees = response.data;

                            if(this.employees.length == 0)
                                this.blankmsg = "Looks like you have not added any employee yet.";
                            else
                            {
                                this.length_options = [{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" }, 
                                                    { value: this.employees.length, text: "All" }
                                                ]; 
                                this.people = this.employees.length;
                            }
                                
                        }

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            getDepertments: function(){
              axios.get(this.$api_url+'/department/list')
              .then(function (response) {
                 this.depertments = response.data;
              }.bind(this));
         
            },
            getJobTypes: function() {
                axios.get(this.$api_url+'/jobposition/options',{
                 params: {
                   
                 }
              }).then(function(response){
                    this.jobtypes = response.data;
                }.bind(this));
            },
            
            getBranches: function(){
              axios.get(this.$api_url+'/branch/list')
              .then(function (response) {
                 this.branches = response.data;
              }.bind(this));
         
            },
            getLeavePolicies: function(){
              axios.get(this.$api_url+'/leave/policy/list')
              .then(function (response) {
                    this.leave_policies = [{ value: 0, text: "Select Leave Policy" } ] . concat(response.data);
              }.bind(this));
         
            },
            

            getManagers: function(){
              axios.get(this.$api_url+'/manager')
              .then(function (response) {                     
                    this.manager = [{ value: 0, text: "Select..." } ] . concat(response.data);
              }.bind(this));
         
            },
            
        },
        created: function(){
            
                  
            this.getDepertments();
            this.getJobTypes();
            this.getBranches();

            this.getEmployees();
            Fire.$on('reloadUsers', () => {this.getEmployees()})


        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.employees;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                       
                }

                this.people = filtered_list.length;
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

        }
    }
</script>